import SignInModalEmailOnly from './sign-in-modal-email-only';

interface Props {
  isOpen: boolean;
  shouldBlurOverlay?: boolean;
  createLink?: string;
  postLoginRedirectUri?: string;
}

/**
 * SignInModal - Unified login/signup modal using email-only flow.
 */
function SignInModal(props: Props) {
  return <SignInModalEmailOnly {...props} />;
}

export default SignInModal;
